import { createToast } from "@/modules/toast-message"
import { computed } from "vue";
import { toFormData } from "@app/helpers/formData";
import { createAsyncApi } from "../../partials/async";

export default function createSubmitProgressionApi(details) {
    /**
     * Updates the progress for an existing key
     * or creates progress
     */
    const submit = createAsyncApi(
        computed(
            () => details.value.key
                ? 'bt_memberships_update_progress'
                : 'bt_memberships_save_progress'
        ),
        'POST',
        {
            parameters: {
                redirect: window.location.href,
            },

            preRequestCallback: data => {
                const { answers: answers, ...core } = data

                return toFormData(
                    {
                        ...core,
                        answers: mapFieldsToSaveFormat(answers)
                    },
                    value => value === null 
                        ? '' 
                        : value
                )
            }
        }
    )

    submit.api.callbacks.add(
        'onError',
        (data) => {
            createToast("Your progress couldn't be saved", "error")
        }
    )

    submit.api.callbacks.add(
        'onSuccess',
        (data) => {
            createToast("Your progress has been saved", "info")

            details.value.key = data.data.uuid

            const url = new URLSearchParams(window.location.search)

            if(!url.has('key')){
                url.append('key', data.data.uuid)
                window.history.replaceState(null, null, `?${url.toString()}`)
            }
        }
    )


    return submit
}

/**
 * Reformats the fields into the format required for submission
 * 
 * @param {Object} fields 
 * @returns {Array}
 */
function mapFieldsToSaveFormat(fields){
    const { fields: fieldData, ...supplementaryData } = fields

    let answers = []

    Object.keys(supplementaryData)
        .forEach((key) => answers.push({
            field_name : key,
            answer     : supplementaryData[key]
        }))

    Object.keys(fieldData)
        .forEach((key) => answers.push({
            field_id   : key.replace('_confirmation', ''),
            field_name : `fields.${key}`,
            answer     : fieldData[key]
        }))

    return answers
}